import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpXhrBackend } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { Studio } from "../models/studio.model";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class StudiosService {
  baseUrl: string = environment.APIURL;

  httpClient = new HttpClient(new HttpXhrBackend({
    build: () => new XMLHttpRequest()
  }));

  // null until loaded; false when the public studios list is empty
  hasStudios$: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);
  private hasStudiosRequested = false;

  constructor(private http: HttpClient) {}

  loadHasStudios() {
    if (this.hasStudiosRequested) {
      return;
    }
    this.hasStudiosRequested = true;

    const params = {
      page: 0,
      size: 1,
      filter: { excludeIds: [0], name: '', country: '' },
      sort: { orders: [{ direction: 'ASC', property: '' }] },
      offset: 0
    };

    this.getStudiosList(params).subscribe({
      next: (response: any) => this.hasStudios$.next(!!response?.items?.length),
      error: () => this.hasStudios$.next(true)
    });
  }

  getStudiosList(params?: any) {
    const path = 'api/public/studios/filter';
    return this.http.post(`${this.baseUrl}${path}`, params);
  }

  youtubePlaylistItems() {
    return this.httpClient.get(`${environment.YOUTUBE}youtube/v3/playlistItems?playlistId=${environment.youtubeChannelId}&key=${environment.youtubeAPIKEY}&part=snippet&maxResults=4`, {});
  }

  youtubeVideoDetails(id: string) {
    return this.httpClient.get(
      `${environment.YOUTUBE}youtube/v3/videos?&key=${environment.youtubeAPIKEY}&part=snippet&part=statistics&id=${id}`
      , {});
  }

  public getStudioDetails(id: number) {
    return this.http.get<Studio>(`${environment.studioApi}api/v1/main/studio/${id}`);
  }

  public getPublicStudioBanner(id: number) {
    return this.http.get(`${environment.studioApi}api/v1/public/studio/${id}/banner-pictures/`);
  }

}
